import { FC } from "react";

import { Box, chakra } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

const Signature: FC = () => {
  const { t } = useTranslation();
  const text = t("pages-order_summary-signature");

  return (
    <>
      {text && text !== "pages-order_summary-signature" && (
        <Box py="1.5rem">
          <chakra.span fontSize="0.875rem">{text}</chakra.span>
        </Box>
      )}
    </>
  );
};
export default Signature;
